jQuery(document).ready(function ($) {
	// Handle video tab clicks
	$(".video-tab").on("click", function () {
		// Update active states on tabs
		$(".video-tab").attr("data-active", "false");
		$(this).attr("data-active", "true");

		// Get the index of clicked tab
		const index = $(this).index();

		// Fade out all video embeds and fade in the selected one
		$(".video-embed").fadeOut(200);
		$(".video-embed").eq(index).delay(200).fadeIn(200);
	});

	// Post item accordion
	const toggleButtons = document.querySelectorAll('.toggle-series-content');
    
    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Find the closest series content list
            const contentList = this.nextElementSibling;
            const arrow = this.querySelector('svg');
            const buttonText = this.querySelector('span');
            
            // Toggle the display
            if (contentList.style.display === 'none') {
                contentList.style.display = 'block';
                arrow.style.transform = 'rotate(180deg)';
                buttonText.textContent = 'Hide series contents';
            } else {
                contentList.style.display = 'none';
                arrow.style.transform = 'rotate(0)';
                buttonText.textContent = 'Show series contents';
            }
        });
    });
});
